/* ============================================================
   BNDT PRODUCT PAGE (PDP) JS — v3 CRO-Enhanced 2026-03-22
   ============================================================ */

(function() {
  'use strict';

  var fiveXExpires = parseInt(sessionStorage.getItem('bndt_5x_expires') || '0', 10);
  var SWEEP_MULT = (fiveXExpires && Date.now() < fiveXExpires) ? 5 : 1;

  /* --- Swatch Gallery with Touch Swipe --- */
  // Global gallery state — accessible to swatch handlers
  window.galleryState = {
    allImages: [],
    filteredIndices: [],
    currentFiltered: 0,
    activeVariantId: null
  };

  function initGallery() {
    var mainImages = document.querySelectorAll('.pdp-main-img');
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var swipeArea = document.querySelector('#pdp-gallery');
    var currentIndex = 0;

    window.galleryState.allImages = Array.from(mainImages);

    if (!mainImages.length) return;

    function showImage(index) {
      var gs = window.galleryState;

      // If we have a filtered set, navigate within it
      if (gs.filteredIndices.length > 0) {
        if (index < 0) index = gs.filteredIndices.length - 1;
        if (index >= gs.filteredIndices.length) index = 0;
        gs.currentFiltered = index;
        currentIndex = gs.filteredIndices[index];
      } else {
        if (index < 0) index = mainImages.length - 1;
        if (index >= mainImages.length) index = 0;
        currentIndex = index;
      }

      mainImages.forEach(function(img, i) {
        if (i === currentIndex) {
          img.classList.add('is-visible');
        } else {
          img.classList.remove('is-visible');
        }
      });
      thumbs.forEach(function(thumb, i) {
        if (i === currentIndex) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      });
    }

    // Filter gallery to a specific variant
    window.filterGalleryByVariant = function(variantId) {
      var gs = window.galleryState;
      gs.activeVariantId = variantId;
      gs.filteredIndices = [];

      if (!variantId) {
        // No filter — show all
        gs.filteredIndices = [];
        gs.currentFiltered = 0;
        showImage(0);
        return;
      }

      // Find the image index for this variant from the swatch data
      var matchedSwatch = document.querySelector('.swatch-item[data-variant-id="' + variantId + '"]');
      var variantImageIdx = matchedSwatch ? parseInt(matchedSwatch.getAttribute('data-image-index') || '-1', 10) : -1;

      // Find the highest variant-assigned image index to determine where lifestyle shots start
      var highestVariantIdx = -1;
      document.querySelectorAll('.swatch-item').forEach(function(s) {
        var idx = parseInt(s.getAttribute('data-image-index') || '-1', 10);
        if (idx >= 0) {
          var pairEnd = idx + 1;
          if (pairEnd > highestVariantIdx) highestVariantIdx = pairEnd;
        }
      });

      if (variantImageIdx >= 0) {
        // This variant's paired images
        gs.filteredIndices.push(variantImageIdx);
        if (variantImageIdx + 1 < gs.allImages.length && variantImageIdx + 1 <= highestVariantIdx) {
          gs.filteredIndices.push(variantImageIdx + 1);
        }
      }

      // Add lifestyle shots (everything after the last variant pair)
      if (highestVariantIdx >= 0) {
        for (var li = highestVariantIdx + 1; li < gs.allImages.length; li++) {
          gs.filteredIndices.push(li);
        }
      }

      // If still empty, show all
      if (gs.filteredIndices.length === 0) {
        gs.allImages.forEach(function(img, i) {
          gs.filteredIndices.push(i);
        });
      }

      // Show the first filtered image
      gs.currentFiltered = 0;
      if (gs.filteredIndices.length > 0) {
        currentIndex = gs.filteredIndices[0];
        mainImages.forEach(function(img, i) {
          img.classList.toggle('is-visible', i === currentIndex);
        });
      }
    };

    // Jump to a specific image index without filtering
    window.jumpToGalleryImage = function(index) {
      var gs = window.galleryState;
      gs.filteredIndices = [];
      gs.currentFiltered = 0;
      showImage(index);
    };

    // Thumb clicks
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        showImage(i);
      });
    });

    // Desktop 2x2 thumbnail grid clicks
    var gridThumbs = document.querySelectorAll('.pdp__thumb-grid-item');
    gridThumbs.forEach(function(gridThumb) {
      gridThumb.addEventListener('click', function() {
        var idx = parseInt(gridThumb.getAttribute('data-grid-index'), 10);
        // Clear filtered indices so we jump to the exact image
        var gs = window.galleryState;
        gs.filteredIndices = [];
        gs.currentFiltered = 0;
        showImage(idx);
        // Update active state on grid thumbs
        gridThumbs.forEach(function(gt) { gt.classList.remove('active'); });
        gridThumb.classList.add('active');
      });
    });

    // Patch showImage to also update grid thumb active states
    var origShowImage = showImage;
    showImage = function(index) {
      origShowImage(index);
      if (gridThumbs.length > 0) {
        gridThumbs.forEach(function(gt) {
          var gi = parseInt(gt.getAttribute('data-grid-index'), 10);
          gt.classList.toggle('active', gi === currentIndex);
        });
      }
    };

    // Touch swipe
    if (swipeArea) {
      var startX = 0;
      var startY = 0;
      var threshold = 50;

      var swipeTarget = null;
      swipeArea.addEventListener('touchstart', function(e) {
        swipeTarget = e.target;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      swipeArea.addEventListener('touchend', function(e) {
        if (swipeTarget && swipeTarget.closest('.swatch-strip')) return;
        var diffX = e.changedTouches[0].clientX - startX;
        var diffY = e.changedTouches[0].clientY - startY;
        var gs = window.galleryState;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > threshold) {
          var navIdx = gs.filteredIndices.length > 0 ? gs.currentFiltered : currentIndex;
          if (diffX < 0) {
            showImage(navIdx + 1);
          } else {
            showImage(navIdx - 1);
          }
        }
      }, { passive: true });

      // Mouse drag swipe for desktop
      var mouseDown = false;
      var mouseStartX = 0;

      swipeArea.addEventListener('mousedown', function(e) {
        mouseDown = true;
        mouseStartX = e.clientX;
        e.preventDefault();
      });

      document.addEventListener('mouseup', function(e) {
        if (!mouseDown) return;
        mouseDown = false;
        var diffX = e.clientX - mouseStartX;
        if (Math.abs(diffX) > threshold) {
          if (diffX < 0) {
            showImage(currentIndex + 1);
          } else {
            showImage(currentIndex - 1);
          }
        }
      });
    }

    // Init first image
    showImage(0);

    // Arrow buttons — navigate within filtered set
    var prevBtn = document.getElementById('gallery-prev');
    var nextBtn = document.getElementById('gallery-next');
    if (prevBtn) prevBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      var gs = window.galleryState;
      if (gs.filteredIndices.length > 0) {
        showImage(gs.currentFiltered - 1);
      } else {
        showImage(currentIndex - 1);
      }
    });
    if (nextBtn) nextBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      var gs = window.galleryState;
      if (gs.filteredIndices.length > 0) {
        showImage(gs.currentFiltered + 1);
      } else {
        showImage(currentIndex + 1);
      }
    });
  }

  /* --- Select Swatch (Variant) --- */
  function initSwatches() {
    var swatches = document.querySelectorAll('.pdp__swatch');
    var variantInput = document.querySelector('input[name="id"]');
    var priceEl = document.querySelector('.pdp__price');
    var comparePriceEl = document.querySelector('.pdp__compare-price');
    var saveBadge = document.querySelector('.pdp__price-save');
    var mainImages = document.querySelectorAll('.pdp-main-img');

    if (!swatches.length) return;

    function selectSwatch(swatch) {
      var variantId = swatch.getAttribute('data-variant-id');
      var price = swatch.getAttribute('data-price');
      var comparePrice = swatch.getAttribute('data-compare-price');
      var imageIndex = swatch.getAttribute('data-image-index');
      var inventory = swatch.getAttribute('data-inventory');

      // Update active state
      swatches.forEach(function(s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');

      // Update variant ID
      if (variantInput) variantInput.value = variantId;

      // Update price
      if (priceEl && price) {
        priceEl.textContent = '$' + (parseFloat(price) / 100).toFixed(2);
      }

      // Update compare price and save badge
      if (comparePriceEl) {
        if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
          comparePriceEl.textContent = '$' + (parseFloat(comparePrice) / 100).toFixed(2);
          comparePriceEl.style.display = '';
          if (saveBadge) {
            var savings = Math.round((parseFloat(comparePrice) - parseFloat(price)) / parseFloat(comparePrice) * 100);
            saveBadge.textContent = 'SAVE ' + savings + '%';
            saveBadge.style.display = '';
          }
        } else {
          comparePriceEl.style.display = 'none';
          if (saveBadge) saveBadge.style.display = 'none';
        }
      }

      // Update low stock indicator
      var lowStockEl = document.getElementById('pdp-low-stock');
      if (inventory !== null && inventory !== '') {
        var qty = parseInt(inventory, 10);
        if (!lowStockEl && qty > 0 && qty <= 10) {
          // Create low stock element if needed
          var priceBlock = document.querySelector('.pdp__price-block');
          if (priceBlock) {
            lowStockEl = document.createElement('div');
            lowStockEl.className = 'pdp__low-stock';
            lowStockEl.id = 'pdp-low-stock';
            lowStockEl.innerHTML = '<span class="pdp__low-stock-dot"></span> Only ' + qty + ' left in stock';
            priceBlock.parentNode.insertBefore(lowStockEl, priceBlock.nextSibling);
          }
        } else if (lowStockEl) {
          if (qty > 0 && qty <= 10) {
            lowStockEl.innerHTML = '<span class="pdp__low-stock-dot"></span> Only ' + qty + ' left in stock';
            lowStockEl.style.display = 'flex';
          } else {
            lowStockEl.style.display = 'none';
          }
        }
      }

      // Update entries
      if (price) {
        updateEntries(parseFloat(price) / 100);
      }

      // Update selected color label + sticky variant name
      var variantTitle = swatch.getAttribute('data-variant-title');
      var selectedColorEl = document.querySelector('.pdp__selected-color');
      if (selectedColorEl && variantTitle) selectedColorEl.textContent = variantTitle;
      var stickyVariantEl = document.getElementById('sticky-variant-name');
      if (stickyVariantEl && variantTitle) stickyVariantEl.textContent = variantTitle;

      // Update sticky ATC price
      var stickyPrice = document.querySelector('.pdp__sticky-atc-price');
      if (stickyPrice && price) {
        stickyPrice.textContent = '$' + (parseFloat(price) / 100).toFixed(2);
      }

      // Update gallery
      if (imageIndex !== null && imageIndex !== '') {
        var idx = parseInt(imageIndex, 10);
        mainImages.forEach(function(img, i) {
          if (i === idx) { img.classList.add('is-visible'); } else { img.classList.remove('is-visible'); }
        });
        document.querySelectorAll('.pdp-thumb').forEach(function(thumb, i) {
          if (i === idx) { thumb.classList.add('active'); } else { thumb.classList.remove('active'); }
        });
      }

      // Update URL
      if (variantId && window.history && window.history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
      }
    }

    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        selectSwatch(swatch);
      });
    });
  }

  /* --- Update Entries --- */
  window.updateEntries = updateEntries;
  function updateEntries(priceInDollars) {
    var entries = Math.floor(priceInDollars) * SWEEP_MULT;
    var displays = document.querySelectorAll('.entry-count-display');
    displays.forEach(function(el) {
      el.textContent = entries;
    });

    // Update calc rows
    var baseEl = document.querySelector('[data-entry-base]');
    var multEl = document.querySelector('[data-entry-mult]');
    var totalEl = document.querySelector('[data-entry-total]');

    if (baseEl) baseEl.textContent = Math.floor(priceInDollars);
    if (multEl) multEl.textContent = SWEEP_MULT + '\u00d7';
    if (totalEl) totalEl.textContent = entries + ' entries';
  }

  /* --- Tracker Toggle --- */
  function initTrackerToggle() {
    var toggle = document.querySelector('.pdp__tracker-toggle');
    if (!toggle) return;

    toggle.addEventListener('change', function() {
      var trackerRow = document.querySelector('.pdp__tracker-upsell');
      if (trackerRow) {
        trackerRow.classList.toggle('is-selected', toggle.checked);
      }
    });
  }

  /* --- Accordion (handles all accordions on page) --- */
  function initAccordion() {
    var triggers = document.querySelectorAll('.pdp__accordion-trigger');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = trigger.closest('.pdp__accordion-item');
        var accordion = trigger.closest('.pdp__accordion');
        var isOpen = item.classList.contains('is-open');

        // Close all in same accordion group
        if (accordion) {
          accordion.querySelectorAll('.pdp__accordion-item').forEach(function(el) {
            el.classList.remove('is-open');
          });
        }

        // Toggle current
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  }

  /* --- Sticky ATC via IntersectionObserver --- */
  function initStickyATC() {
    var mainATCBtn = document.querySelector('.pdp__atc-btn');
    var stickyBar = document.querySelector('#sticky-atc');
    if (!mainATCBtn || !stickyBar) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          stickyBar.classList.add('is-visible');
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0
    });

    observer.observe(mainATCBtn);
  }

  /* --- ATC Feedback --- */
  function initATC() {
    // ATC submit handling is done by the tracker override handler below
    // This function only sets up the sticky ATC button

    // Sticky ATC button — triggers the main form's ATC logic
    var stickyBtn = document.querySelector('.pdp__sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var mainForm = document.querySelector('.pdp__atc-form');
        var mainBtn = mainForm ? mainForm.querySelector('.pdp__atc-btn') : null;
        if (!mainForm) return;

        var variantId = mainForm.querySelector('input[name="id"]').value;
        var qty = parseInt(mainForm.querySelector('input[name="quantity"]').value || '1', 10);

        var bundleCb = document.getElementById('pdp-bundle-cb');
        var isBundled = bundleCb && bundleCb.checked;
        if (isBundled) qty = 2;

        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Adding...';

        var stickyItems = [{ id: parseInt(variantId, 10), quantity: qty }];
        if (trackerOn) {
          stickyItems.push({ id: TRACKER_VARIANT_ID, quantity: 1 });
        }
        if (clipOn) {
          stickyItems.push({ id: CLIP_VARIANT_ID, quantity: 1 });
        }
        if (holderOn) {
          stickyItems.push({ id: HOLDER_VARIANT_ID, quantity: 1 });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: stickyItems })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          // Apply discount: bundle takes priority
          if (isBundled) return fetch('/discount/BUNDLE15');
          if (trackerOn) return fetch('/discount/' + TRACKER_DISCOUNT_CODE);
          if (holderOn && HOLDER_FREE_CODE) return fetch('/discount/' + HOLDER_FREE_CODE);
        })
        .then(function() {
          stickyBtn.textContent = '\u2713 Added!';
          stickyBtn.style.background = 'var(--green, #1e6641)';
          setTimeout(function() { if (window.BNDT && window.BNDT.openCartDrawer) { window.BNDT.openCartDrawer(); } else { window.location.href = '/cart'; } }, 600);
        })
        .catch(function() {
          stickyBtn.textContent = 'Add to Cart';
          stickyBtn.disabled = false;
        });
      });
    }
  }

  /* --- Quantity Picker --- */
  function initQtyPicker() {
    var minusBtns = document.querySelectorAll('.pdp__qty-btn--minus');
    var plusBtns = document.querySelectorAll('.pdp__qty-btn--plus');

    minusBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('.pdp__qty-input');
        var val = parseInt(input.value, 10);
        if (val > 1) input.value = val - 1;
      });
    });

    plusBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('.pdp__qty-input');
        var val = parseInt(input.value, 10);
        if (val < 99) input.value = val + 1;
      });
    });
  }

  /* --- Email Subscribe Validation --- */
  function initEmailCapture() {
    var form = document.querySelector('.pdp__email-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = form.querySelector('.pdp__email-input');
      var successMsg = document.querySelector('.pdp__email-success');
      var errorMsg = document.querySelector('.pdp__email-error');

      if (!input || !input.value) return;

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(input.value)) {
        if (errorMsg) {
          errorMsg.textContent = 'Please enter a valid email address.';
          errorMsg.style.display = 'block';
        }
        if (successMsg) successMsg.style.display = 'none';
        return;
      }

      if (errorMsg) errorMsg.style.display = 'none';
      if (successMsg) {
        successMsg.style.display = 'block';
        successMsg.textContent = 'You\'re in! Check your inbox for confirmation.';
      }
      input.value = '';
    });
  }

  /* --- CRO: Social Proof Buyers Count --- */
  function initSocialProof() {
    var el = document.querySelector('[data-buyers-count]');
    if (!el) return;
    var count = Math.floor(Math.random() * (89 - 30 + 1)) + 30;
    el.textContent = count;
  }

  /* --- CRO: Shipping Countdown Timer (2:20 PM PST cutoff) --- */
  function initShipCountdown() {
    var hoursEl = document.querySelector('[data-ship-hours]');
    var minsEl = document.querySelector('[data-ship-mins]');
    var container = document.getElementById('pdp-ship-countdown');
    if (!hoursEl || !minsEl) return;

    function getSecondsUntilCutoff() {
      var now = new Date();
      // Get current time in PST (UTC-8) / PDT (UTC-7)
      var pstStr = now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      var pstNow = new Date(pstStr);
      var cutoff = new Date(pstNow);
      cutoff.setHours(14, 20, 0, 0); // 2:20 PM

      var diff = Math.floor((cutoff - pstNow) / 1000);
      return diff;
    }

    function updateDisplay() {
      var totalSeconds = getSecondsUntilCutoff();
      if (totalSeconds <= 0) {
        // Past cutoff — hide the countdown or show next day message
        if (container) container.innerHTML = '<span>🚚</span> <span>Order now for <strong>shipping tomorrow</strong></span>';
        return;
      }
      var h = Math.floor(totalSeconds / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      hoursEl.textContent = h;
      minsEl.textContent = m < 10 ? '0' + m : m;
    }

    updateDisplay();
    setInterval(updateDisplay, 60000); // Update every minute
  }

  /* --- CRO: Estimated Delivery Date --- */
  function initDeliveryEstimate() {
    var el = document.querySelector('[data-delivery-date]');
    if (!el) return;

    function getEstimate() {
      var now = new Date();
      var pstStr = now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      var pstNow = new Date(pstStr);
      var cutoff = new Date(pstNow);
      cutoff.setHours(14, 20, 0, 0);

      /* Ship date: today if before cutoff on a weekday, else next business day */
      var shipDate = new Date(pstNow);
      if (pstNow > cutoff || pstNow.getDay() === 0 || pstNow.getDay() === 6) {
        shipDate.setDate(shipDate.getDate() + 1);
      }
      /* Skip to Monday if ship date lands on weekend */
      while (shipDate.getDay() === 0 || shipDate.getDay() === 6) {
        shipDate.setDate(shipDate.getDate() + 1);
      }

      /* Add 3-5 business days for delivery window */
      function addBusinessDays(date, days) {
        var d = new Date(date);
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) added++;
        }
        return d;
      }

      var earliest = addBusinessDays(shipDate, 3);
      var latest = addBusinessDays(shipDate, 5);
      return { earliest: earliest, latest: latest };
    }

    function formatDate(d) {
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
    }

    var est = getEstimate();
    if (est.earliest.getMonth() === est.latest.getMonth() && est.earliest.getDate() === est.latest.getDate()) {
      el.textContent = formatDate(est.earliest);
    } else {
      el.textContent = formatDate(est.earliest) + ' – ' + formatDate(est.latest);
    }
  }

  /* --- Swatch Strip (overlay on gallery) --- */
  function initSwatchStrip() {
    var items = document.querySelectorAll('.swatch-item');
    var mainImages = document.querySelectorAll('.pdp-main-img');
    var variantInput = document.querySelector('input[name="id"]');
    var priceEl = document.querySelector('.pdp__price');
    var comparePriceEl = document.querySelector('.pdp__compare-price');
    var saveBadge = document.querySelector('.pdp__price-save');
    var selectedColorEl = document.getElementById('selected-color-name');
    var stickyVariantEl = document.getElementById('sticky-variant-name');
    var stickyPrice = document.querySelector('.pdp__sticky-atc-price');

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        var vid = item.getAttribute('data-variant-id');
        var price = item.getAttribute('data-price');
        var available = item.getAttribute('data-available');

        // Show/hide ATC vs Notify based on availability
        var atcForm = document.querySelector('.pdp__atc-form');
        var notifyBlock = document.getElementById('pdp-notify');
        var stickyAtc = document.getElementById('sticky-atc');
        var isAvailable = (available === 'true');

        if (atcForm) {
          var atcBtn = atcForm.querySelector('.pdp__atc-btn');
          var stickyBtn = document.querySelector('.pdp__sticky-atc-btn');
          var socialProof = document.getElementById('pdp-social-proof');
          var deliveryEst = document.getElementById('pdp-delivery-estimate');
          if (isAvailable) {
            if (atcBtn) { atcBtn.style.display = ''; atcBtn.disabled = false; }
            if (notifyBlock) notifyBlock.style.display = 'none';
            if (stickyBtn) stickyBtn.style.display = '';
            if (stickyAtc) stickyAtc.style.display = '';
            if (socialProof) socialProof.style.display = '';
            if (deliveryEst) deliveryEst.style.display = '';
          } else {
            if (atcBtn) { atcBtn.style.display = 'none'; atcBtn.disabled = true; }
            if (notifyBlock) { notifyBlock.style.display = 'block'; document.getElementById('notify-form').style.display = 'flex'; document.getElementById('notify-success').style.display = 'none'; }
            if (stickyBtn) stickyBtn.style.display = 'none';
            if (stickyAtc) stickyAtc.style.display = 'none';
            if (socialProof) socialProof.style.display = 'none';
            if (deliveryEst) deliveryEst.style.display = 'none';
          }
        }
        var comparePrice = item.getAttribute('data-compare-price');
        var imgIdx = item.getAttribute('data-image-index');
        var title = item.getAttribute('data-variant-title');

        // Active state
        items.forEach(function(s) { s.classList.remove('active'); });
        item.classList.add('active');

        // Variant ID
        if (variantInput) variantInput.value = vid;

        // Member Exclusive badge swap
        var memberExclusive = item.getAttribute('data-member-exclusive') === 'true';
        var pdpBadge = document.getElementById('pdp-badge');
        if (pdpBadge) {
          if (memberExclusive) {
            pdpBadge.textContent = 'Member Exclusive';
            pdpBadge.classList.add('is-member');
          } else {
            pdpBadge.textContent = 'Best Seller';
            pdpBadge.classList.remove('is-member');
          }
        }

        // Price
        if (priceEl && price) priceEl.textContent = '$' + (parseFloat(price) / 100).toFixed(2);

        // Compare price + save badge
        if (comparePriceEl) {
          if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
            comparePriceEl.textContent = '$' + (parseFloat(comparePrice) / 100).toFixed(2);
            comparePriceEl.style.display = '';
            if (saveBadge) {
              var savings = Math.round((parseFloat(comparePrice) - parseFloat(price)) / parseFloat(comparePrice) * 100);
              saveBadge.textContent = 'SAVE ' + savings + '%';
              saveBadge.style.display = '';
            }
          } else {
            comparePriceEl.style.display = 'none';
            if (saveBadge) saveBadge.style.display = 'none';
          }
        }

        // Jump to this variant's image without locking the gallery
        if (window.jumpToGalleryImage) {
          var imgIdx = parseInt(item.getAttribute('data-image-index') || '0', 10);
          window.jumpToGalleryImage(imgIdx);
        }

        // Color label + sticky
        if (selectedColorEl && title) selectedColorEl.textContent = title;
        if (stickyVariantEl && title) stickyVariantEl.textContent = title;
        if (stickyPrice && price) stickyPrice.textContent = '$' + (parseFloat(price) / 100).toFixed(2);

        // Update sticky ATC thumbnail to match selected variant image
        var stickyImg = document.getElementById('sticky-atc-img');
        if (stickyImg && imgIdx !== null && imgIdx !== '') {
          var activeMainImg = document.querySelector('.pdp-main-img[data-index="' + imgIdx + '"]');
          if (activeMainImg) {
            stickyImg.src = activeMainImg.src.replace('_550x550', '_80x80_crop_center').replace('_100x100', '_80x80_crop_center');
          }
        }

        // Entries
        if (price) updateEntries(parseFloat(price) / 100);

        // URL
        if (vid && window.history && window.history.replaceState) {
          var url = new URL(window.location);
          url.searchParams.set('variant', vid);
          window.history.replaceState({}, '', url);
        }
      });
    });
  }

  /* --- Init All --- */
  document.addEventListener('DOMContentLoaded', function() {
    initGallery();
    initSwatches();
    initSwatchStrip();
    initAccordion();
    initStickyATC();
    initATC();
    initQtyPicker();
    initEmailCapture();
    initSocialProof();
    initShipCountdown();
    initDeliveryEstimate();

    // Desktop variant image buttons → trigger swatch selection
    var varImgBtns = document.querySelectorAll('.pdp__variant-img-btn');
    var swatchItems = document.querySelectorAll('.swatch-item');
    varImgBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var vid = btn.dataset.variantId;
        // Find and click matching swatch
        swatchItems.forEach(function(sw) {
          if (sw.dataset.variantId === vid) { sw.click(); }
        });
        // Update active state on image buttons
        varImgBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
    // Sync image buttons when swatch strip changes
    swatchItems.forEach(function(sw) {
      sw.addEventListener('click', function() {
        var vid = sw.dataset.variantId;
        varImgBtns.forEach(function(b) {
          b.classList.toggle('is-active', b.dataset.variantId === vid);
        });
      });
    });

    // Initial entry calculation
    var priceEl = document.querySelector('.pdp__price');
    if (priceEl) {
      var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
      var priceVal = parseFloat(priceText);
      if (!isNaN(priceVal)) {
        updateEntries(priceVal);
      }
    }
  });

})();

/* --- Notify Back in Stock (Klaviyo) --- */
var KLAVIYO_COMPANY_ID = 'Wv2fiz';

function submitNotify(e) {
  e.preventDefault();
  var email = document.getElementById('notify-email').value;
  if (!email) return false;

  var variantId = document.querySelector('input[name="id"]') ? document.querySelector('input[name="id"]').value : '';
  var btn = document.querySelector('.pdp__notify-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Subscribing...'; }

  // Identify the user in Klaviyo
  var _learnq = window._learnq || [];
  _learnq.push(['identify', { '$email': email }]);

  // Use Klaviyo's new Client API for Back in Stock
  fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15'
    },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    })
  })
  .then(function(r) {
    document.getElementById('notify-form').style.display = 'none';
    document.getElementById('notify-success').style.display = 'block';
  })
  .catch(function(err) {
    console.error('Klaviyo BIS error:', err);
    // Fallback: track event directly
    _learnq.push(['track', 'Back In Stock Subscribe', {
      'VariantId': variantId,
      'URL': window.location.href
    }]);
    document.getElementById('notify-form').style.display = 'none';
    document.getElementById('notify-success').style.display = 'block';
  });

  return false;
}

/* --- Tracker Toggle (global for onclick) --- */
var trackerOn = false;
var TRACKER_VARIANT_ID = 50286098612533;
var TRACKER_PRICE = 30;
var TRACKER_DISCOUNT_CODE = 'trackerbundle';

/* --- Money Clip Toggle --- */
var clipOn = false;
var CLIP_VARIANT_ID = 53210205061429;
var CLIP_PRICE = 25;

/* --- Eyeglass Holder Toggle (sunglasses PDP) --- */
var holderOn = false;
var HOLDER_VARIANT_ID = 53210205126965;
var HOLDER_PRICE = 35;
var HOLDER_FREE_CODE = '';
(function(){ var t = document.getElementById('holder-toggle'); if (t) { HOLDER_VARIANT_ID = parseInt(t.getAttribute('data-holder-variant-id'), 10) || HOLDER_VARIANT_ID; HOLDER_PRICE = parseFloat(t.getAttribute('data-holder-price')) || HOLDER_PRICE; HOLDER_FREE_CODE = t.getAttribute('data-free-code') || ''; if (HOLDER_FREE_CODE) { holderOn = true; } } })();
function toggleHolder() {
  holderOn = !holderOn;
  var wrap = document.getElementById('holder-toggle-wrap');
  var toggle = document.getElementById('holder-toggle');
  if (wrap) wrap.classList.toggle('on', holderOn);
  if (toggle) toggle.classList.toggle('on', holderOn);
  bndtRefreshAtc();
}

function bndtAddonTotal() {
  var priceEl = document.querySelector('.pdp__price');
  var basePrice = priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) : 0;
  if (trackerOn) basePrice += TRACKER_PRICE;
  if (clipOn) basePrice += CLIP_PRICE;
  if (holderOn && !HOLDER_FREE_CODE) basePrice += HOLDER_PRICE;
  return basePrice;
}

function bndtRefreshAtc() {
  var total = bndtAddonTotal();
  var atcBtn = document.querySelector('.pdp__atc-btn');
  if (atcBtn) atcBtn.textContent = 'Add to Cart \u2014 $' + total.toFixed(2);
  var stickyBtn = document.querySelector('.pdp__sticky-atc-btn');
  if (stickyBtn) stickyBtn.textContent = 'Add to Cart \u2014 $' + total.toFixed(2);
  if (window.updateEntries) window.updateEntries(total);
}

function toggleClip() {
  clipOn = !clipOn;
  var wrap = document.getElementById('clip-toggle-wrap');
  var toggle = document.getElementById('clip-toggle');
  if (wrap) wrap.classList.toggle('on', clipOn);
  if (toggle) toggle.classList.toggle('on', clipOn);
  bndtRefreshAtc();
}

function toggleTracker() {
  trackerOn = !trackerOn;
  var wrap = document.getElementById('toggle-wrap');
  var toggle = document.getElementById('tracker-toggle');
  if (wrap) wrap.classList.toggle('on', trackerOn);
  if (toggle) toggle.classList.toggle('on', trackerOn);

  bndtRefreshAtc();
}

/* Override ATC to include tracker when toggled + apply discount code */
document.addEventListener('DOMContentLoaded', function() {
  var atcForm = document.querySelector('.pdp__atc-form');
  if (!atcForm) return;

  atcForm.addEventListener('submit', function(e) {
    e.preventDefault(); // Always prevent default — handle everything via JS

    var variantId = atcForm.querySelector('input[name="id"]').value;
    var qty = parseInt(atcForm.querySelector('input[name="quantity"]').value || '1', 10);
    var btn = atcForm.querySelector('.pdp__atc-btn');

    // Check bundle checkbox
    var bundleCb = document.getElementById('pdp-bundle-cb');
    var isBundled = bundleCb && bundleCb.checked;
    if (isBundled) qty = 2;

    var items = [{ id: parseInt(variantId, 10), quantity: qty }];
    if (trackerOn) {
      items.push({ id: TRACKER_VARIANT_ID, quantity: 1 });
    }
    if (clipOn) {
      items.push({ id: CLIP_VARIANT_ID, quantity: 1 });
    }
    if (holderOn) {
      items.push({ id: HOLDER_VARIANT_ID, quantity: 1 });
    }

    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Apply discount: bundle takes priority (15% off everything including tracker)
      if (isBundled) return fetch('/discount/BUNDLE15');
      if (trackerOn) return fetch('/discount/' + TRACKER_DISCOUNT_CODE);
      if (holderOn && HOLDER_FREE_CODE) return fetch('/discount/' + HOLDER_FREE_CODE);
    })
    .then(function() {
      if (btn) {
        btn.classList.add('is-added');
        btn.textContent = '\u2713 Added!';
      }
      setTimeout(function() { if (window.BNDT && window.BNDT.openCartDrawer) { window.BNDT.openCartDrawer(); } else { window.location.href = '/cart'; } }, 600);
    })
    .catch(function(err) {
      console.error('ATC error:', err);
      if (btn) { btn.disabled = false; }
    });
  });
});


/* ===== PDP gallery video: autoplay on its slide, pause off it (added 2026-08-26) =====
   Written as an additive block rather than editing showImage(), which has 23
   call sites. The slider already toggles .is-visible on every .pdp-main-img,
   and video slides carry that same class, so we only watch for the class
   change and pause anything that scrolled away. */
(function () {
  function initPdpGalleryVideo() {
    var host = document.querySelector('.pdp__gallery-main');
    if (!host) return;
    var slides = host.querySelectorAll('.pdp-main-video');
    if (!slides.length) return;

    function sync() {
      slides.forEach(function (slide) {
        var v = slide.querySelector('video');
        if (!v) return;
        var showing = slide.classList.contains('is-visible');
        if (!showing) {
          if (!v.paused) v.pause();
        } else if (v.paused) {
          // Autoplay only ever works muted. Keep it muted here so returning to
          // the slide resumes reliably instead of being blocked by the browser.
          v.muted = true;
          var p = v.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        }
      });
    }

    var mo = new MutationObserver(sync);
    slides.forEach(function (slide) {
      mo.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpGalleryVideo);
  } else {
    initPdpGalleryVideo();
  }
})();
